
export const GENERAL_STATUS = [
  { label: 'Activo', value: 0, color: 'success' },
  { label: 'Inactivo', value: 1, color: 'error' },
  { label: 'Usado', value: 2, color: 'warning' },
  { label: 'Parcial', value: 3, color: 'warning' },
  { label: 'Inicializado', value: 4, color: 'info' },
  { label: 'Cerrado', value: 5, color: 'error' },
  { label: 'Paciente Incompleto', value: 6, color: 'error' },
  { label: 'Disponible', value: 7, color: 'success' },
  { label: 'Pendiente', value: 8, color: 'warning' },
  { label: 'Aprobado', value: 9, color: 'success' },
  { label: 'Cancelado', value: 10, color: 'error' },
  { label: 'Problema', value: 11, color: 'error' },
  { label: 'Procesando', value: 12, color: 'info' },
  { label: 'Completado', value: 13, color: 'success' },
  { label: 'Glosa', value: 14, color: 'error' },
];

export const PAYMENT_METHODS = [
  { label: 'Transferencia', value: 0 },
  { label: 'Tarjeta', value: 1 },
  { label: 'Efectivo', value: 2 },
  { label: 'Nota de Crédito', value: 3 },
  { label: 'Cheque', value: 4 },
  { label: 'Split', value: 5 },
  { label: 'Depósito', value: 6 },
];

export const OPERATION_AREA = [
  { label: "Consejo de doctores", value: 1 },
  { label: "UCI", value: 2 }
]


export const EMPLOYEE_STATUS = [
  { label: 'Activo', value: 0 },
  { label: 'Inactivo', value: 1 },
  { label: 'De Vacaciones', value: 2 },
  { label: 'Ausente', value: 3 },
  { label: 'Con Licencia', value: 4 },
  { label: 'Licencia de Maternidad', value: 5 },
  { label: 'Licencia Parental', value: 6 },
  { label: 'Solicitante', value: 7 },
  { label: 'Candidato', value: 8 },
  { label: 'Desvinculado', value: 9 },
  { label: 'Pendiente de admisión', value: 10 },
];

export const DOCUMENT_TYPE = [
  { Label: 'Cédula', value: 0 },
  { label: 'Pasaporte', value: 1 },
];

export const PAYROLL_STATUS = [
  { label: 'En revisión', value: 0 },
  { label: 'Inactivo', value: 1 },
  { label: 'Usado', value: 2 },
  { label: 'Parcial', value: 3 },
  { label: 'Inicializado', value: 4 },
  { label: 'Cerrado', value: 5 },
  { label: 'Paciente Incompleto', value: 6 },
  { label: 'Disponible', value: 7 },
  { label: 'Pendiente', value: 8 },
  { label: 'Aprobado', value: 9 },
  { label: 'Cancelado', value: 10 },
  { label: 'Problema', value: 11 },
  { label: 'Procesando', value: 12 },
  { label: 'Completado', value: 13 },
  { label: 'Glosa', value: 14 },
];

export const PAYROLL_TYPES = [
  { label: 'Empleados', value: 0 },
  { label: 'Doctores', value: 1 },
];

export const DOCTOR_PAYROLL_TYPES = [
  { label: 'Services (Laboratorios e imagenes)', value: 0 },
  { label: 'Planta y admisiones', value: 1 },
  { label: 'Emergencia', value: 2 },
  { label: 'Especialidad', value: 3 },
  { label: 'Pago fijo de doctores', value: 4 },
];

export const PAYMENT_STATUS = [
  { label: 'Activo', value: 0 },
  { label: 'Desactivado', value: 1 },
  { label: 'Usado', value: 2 },
  { label: 'Parcial', value: 3 },
  { label: 'Inicializado', value: 4 },
  { label: 'Cerrado', value: 5 },
];

export const POS_PROCESS_STATUS = [
  { label: 'Completo', value: 0, color: 'success' },
  { label: 'Parcial', value: 1, color: 'warning' },
  { label: 'No pagado', value: 2, color: 'error' },
];

export const PATIENT_STATUS = [
  'Ambulatorio',                 // 0
  'Emergencia',                  // 1
  'Hospitalizado',               // 2
  'Paciente Interno',            // 3
  'Creado',                      // 4
  'Actualizado',                 // 5
  'Admitido',                    // 6
  'Procesando',                  // 7
  'Detenido',                    // 8
  'Alta',                        // 9
  'Medicado',                    // 10
  'UCI',                         // 11
  'Laboratorio',                 // 12
  'Imágenes Médicas',            // 13
  'Abandonado',                  // 14
  'Interconsulta',               // 15
  'Interconsulta Actualizada',   // 16
  'Consulta',                 // 17
];

export const DOSE_TYPE = [
  { value: 0, label: 'Milligrams' }, // mg
  { value: 1, label: 'Grams' }, // g
  { value: 2, label: 'Kilograms' }, // kg
  { value: 3, label: 'Milliliters' }, // ml
  { value: 4, label: 'Liters' }, // L
  { value: 5, label: 'Micrograms' }, // mcg
  { value: 6, label: 'Units' }, // U
  { value: 7, label: 'InternationalUnits' }, // IU
  { value: 8, label: 'Drops' }, // gtt
  { value: 9, label: 'Tablets' },
  { value: 10, label: 'Capsules' },
  { value: 11, label: 'Patches' },
  { value: 12, label: 'Inhalations' },
  { value: 13, label: 'Vials' },
  { value: 14, label: 'Ampoules' },
  { value: 15, label: 'Syringes' },
  { value: 16, label: 'Doses' },
  { value: 17, label: 'Percent' }, // %
  { value: 18, label: 'Milliequivalents' }, // mEq
  { value: 19, label: 'Centimeters' }, // cm
  { value: 20, label: 'Meters' }, // m
  { value: 21, label: 'SquareCentimeters' }, // cm²
  { value: 22, label: 'SquareMeters' }, // m²
  { value: 23, label: 'Millimoles' }, // mmol
  { value: 24, label: 'Moles' }, // mol
  { value: 25, label: 'Hours' }, // h
  { value: 26, label: 'Minutes' }, // min
  { value: 27, label: 'Seconds' }, // s
  { value: 28, label: 'Joules' }, // J
  { value: 29, label: 'Calories' }, // cal
  { value: 30, label: 'Kilocalories' }, // kcal
  { value: 31, label: 'DegreesCelsius' }, // °C
  { value: 32, label: 'BeatsPerMinute' }, // bpm
  { value: 33, label: 'BloodPressure' }, // mmHg
  { value: 34, label: 'Saturation' }, // %
  { value: 35, label: 'Volts' }, // V
  { value: 36, label: 'Amperes' }, // A
  { value: 37, label: 'Ohms' }, // Ω
  { value: 38, label: 'Milliwatts' }, // mW
];

export const PATIENT_STATUS_VALUES = [
  { label: 'Ambulatorio', value: 0, acronym: 'AMB' },
  { label: 'Emergencia', value: 1, acronym: 'EM' },
  { label: 'Internamiento', value: 2, acronym: 'HOS' },
 
  { label: 'Creado', value: 4, acronym: 'CR' },
  { label: 'Actualizado', value: 5, acronym: 'ACT' },
  { label: 'Admitido', value: 6, acronym: 'ADM' },
  { label: 'Procesando', value: 7, acronym: 'PRO' },
  { label: 'Detenido', value: 8, acronym: 'DET' },
  { label: 'Alta', value: 9, acronym: 'ALT' },
  { label: 'Medicado', value: 10, acronym: 'MED' },
  { label: 'Cuidados Intensivos', value: 11, acronym: 'UCI' },
];


export const TYPE_OF_GOODS_SERVICES_PURCHASED = [
  { label: 'Gastos de personal', value: 1 },
  { label: 'Gastos por trabajo, suministros y servicios', value: 2 },
  { label: 'Arrendamientos', value: 3 },
  { label: 'Gastos de activos fijos', value: 4 },
  { label: 'Gastos de representación', value: 5 },
  { label: 'Otras deducciones admitidas', value: 6 },
  { label: 'Gastos financieros', value: 7 },
  { label: 'Gastos extraordinarios', value: 8 },
  { label: 'Costo de venta', value: 9 },
  { label: 'Activos intangibles', value: 10 },
  { label: 'Gastos reembolsables a terceros', value: 11 },
  { label: 'Pagos a terceros por cuenta de terceros', value: 12 },
  { label: 'Gastos no deducibles', value: 13 },
  { label: 'Pagos por retenciones (ISR/ITBIS)', value: 14 },
  { label: 'Pagos al exterior', value: 15 },
  { label: 'Otras operaciones sin ITBIS', value: 16 },
];

export const TYPE_INCOME = [
  { label: "Ingresos por operaciones (No financieros)", value: 1 },
  { label: "Ingresos Financieros", value : 2 },
  { label: "Ingresos Extraordinarios" , value: 3 },
  { label: "Ingresos por Arrendamientos", value: 4 },
  { label: "Ingresos por Venta de Activo Depreciable", value: 5 },
  { label: "Otros Ingresos", value: 6 }
]

export const INCOME_TAX_WITHHOLDING_TYPE_ISR = [
  { label: 'Alquileres', value: 1 },
  { label: 'Honorarios por servicios personales', value: 2 },
  { label: 'Servicios técnicos', value: 3 },
  { label: 'Servicios de personas jurídicas', value: 4 },
  { label: 'Intereses', value: 5 },
  { label: 'Proveedor informal', value: 6 },
  { label: 'Premios', value: 7 },
  { label: 'Otras retenciones', value: 8 },
];

export const PAYMENT_TYPE_606 = [
  { label: 'Efectivo', value: 1 },
  { label: 'Cheques/Transferencias/Depósito', value: 2 },
  { label: 'Tarjeta Crédito/Débito', value: 3 },
  { label: 'Compra a Crédito', value: 4 },
  { label: 'Permuta', value: 5 },
  { label: 'Nota de Crédito', value: 6 },
  { label: 'Mixto', value: 7 },
];

export const TYPE_ID_REPORT = [
  { label: "RNC", value: 1 },
  { label: "Cédula", value: 2},
  { label: "Pasaporte", value: 3}
]

export const DOCNAME = [
  { label: 'Documento de Identidad Posterior', value: 'cardIdBack' },
  { label: 'Documento de Identidad Frontal', value: 'cardIdFront' },
  { label: 'Seguro Médico Posterior', value: 'insuranceBack' },
  { label: 'Seguro Médico Frontal', value: 'insuranceFront' },
];

export const PATIENT_STATUS_ICONS = [
  {
    label: 'Ambulatorio',
    icon: 'streamline:good-health-and-well-being-solid',
    color: 'info',
    colorHex: '#2196F3',
  },
  { label: 'Emergencia', icon: 'ic:round-emergency', color: 'error', colorHex: '#FF5252' },
  { label: 'Internamiento', icon: 'healthicons:inpatient', color: 'warning', colorHex: '#FF9800' },
  { label: 'Internamiento', icon: 'healthicons:inpatient', color: 'warning', colorHex: '#FF9800' },
  { label: 'Creado', icon: 'material-symbols:inpatient', color: 'success', colorHex: '#4CAF50' },
  {
    label: 'Actualizado',
    icon: 'icon-park-solid:update-rotation',
    color: 'secondary',
    colorHex: '#9E9E9E',
  },
  {
    label: 'Admitido',
    icon: 'icon-park-outline:hospital-bed',
    color: 'success',
    colorHex: '#4CAF50',
  },
  {
    label: 'Procesando',
    icon: 'icon-park-solid:loading-three',
    color: 'info',
    colorHex: '#2196F3',
  },
  { label: 'Detenido', icon: 'akar-icons:stop-fill', color: 'warning', colorHex: '#FF9800' },
  {
    label: 'Alta Médica',
    icon: 'healthicons:health-data-security',
    color: 'success',
    colorHex: '#4CAF50',
  },
  { label: 'Medicado', icon: 'fa6-solid:pills', color: 'primary', colorHex: '#3F51B5' },
  {
    label: 'Cuidados Intensivos',
    icon: 'medical-icon:intensive-care',
    color: 'error',
    colorHex: '#FF5252',
  },
];

export const ROOM_TYPE = ['Emergencia', 'Internamiento', 'Ambulatorio', 'UCI', 'Quirófano'];

export const ShiftProductRequestStatus = ['Pendiente', 'Parcial', 'Completo', 'Cerrado'];

export const PRODUCT_TYPE = [
  { label: 'Medicamento', value: 0 },
  { label: 'Insumo', value: 1 },
  { label: 'Reactivos', value: 2 },
  { label: 'Equipo Médico', value: 3 },
  { label: 'Material de Oficina', value: 4 },
];

export const SERVICE_TYPE = [
  { label: 'Laboratorios', value: 0 },
  { label: 'Imágenes Médicas', value: 1 },
  { label: 'Cardiología', value: 2 },
  { label: 'Cirugía', value: 3 },
  { label: 'Estudios Especiales', value: 4 },
];

export const FIXED_ASSETS_CONDITION = [
  { label: 'Nuevo', value: 0 },
  { label: 'Usado', value: 1 },
  { label: 'Reacondicionado', value: 2 },
  { label: 'Dañado', value: 3 },
  { label: 'En Reparación', value: 4 },
  { label: 'Obsoleto', value: 5 },
  { label: 'Desmantelado', value: 6 },
  { label: 'Alquilado', value: 7 },
  { label: 'Descontinuado', value: 8 },
];

export const MEDICAL_NOTE_TYPE = [
  { label: 'Evolución del Paciente', value: 0 },
  { label: 'Nota Médica', value: 1 },
  { label: 'Nota de Enfermería', value: 2 },
];

export const INVENTORY_MECHANDISE_ENTRY_TYPE = [
  { label: 'Orden de Compra', valueFromEnum: 'purchaseOrder', value: 11 },
  { label: 'Requisición', valueFromEnum: 'requisitionOrder', value: 12 },
  { label: 'Compra Directa', valueFromEnum: 'directPurchase', value: 13 },
  { label: 'Devolución', valueFromEnum: 'return', value: 3 },
];

export const ENTRY_ADJUSTMENT_TYPE = [
  { label: 'Aumento', value: 21 },
  { label: 'Disminuir', value: 22 },
];

export const PHYSICAL_PRODUCT_ENTRY = [
  { label: 'Botella', value: 0 }, // Bottle
  { label: 'Ampolla', value: 1 }, // Ampoule
  { label: 'Bolsa IV', value: 2 }, // IVBag
  { label: 'Atomizador', value: 3 }, // SprayBottle
  { label: 'Blíster', value: 4 }, // Blister
  { label: 'Tubo', value: 5 }, // Tube
  { label: 'Caja', value: 6 }, // Box
];

export const ADJUSTMENT_REASONS = [
  { label: 'Inventario inicial', value: 0 },
  { label: 'Reconteo físico', value: 1 },
  { label: 'Producto encontrado', value: 2 },
  { label: 'Error de sistema anterior', value: 3 },
  { label: 'Devolución de préstamo', value: 4 },
  { label: 'Corrección de entrada faltante', value: 5 },
  { label: 'Producto recuperado', value: 6 },
  { label: 'Ajuste por auditoría', value: 7 },
];

export const COMBO_BOX_TYPE = [{ label: 'Productos', value: 0 }];

// CATÁLOGO DE CUENTAS ENUMS
export const ACCOUNT_TYPE = [
  { label: 'Cuenta de Control', value: 0 },
  { label: 'Cuenta de Movimiento', value: 1 },
];

export const ACCOUNT_TYPE_USE = [
  { label: 'Todos', value: 0 },
  { label: 'Inventario', value: 1 },
  { label: 'Pago', value: 2 },
  { label: 'Préstamo', value: 3 },
  { label: 'Nómina', value: 4 },
  { label: 'Seguro', value: 5 },
  { label: 'Cliente', value: 6 },
  { label: 'Proveedor', value: 7 },
  { label: 'Ingresos', value: 8 },
  { label: 'Ventas', value: 9 },
  { label: 'Servicios', value: 10 },
  { label: 'Punto de Venta', value: 11 },
  { label: 'Costos', value: 12 },
  { label: 'Banco/Efectivo', value: 13 },
  { label: 'Ajuste Positivo', value: 14 },
  { label: 'Ajuste Negativo', value: 15 },
  { label: 'Cuentas por Pagar', value: 16 },
  { label: 'Cuentas por Cobrar', value: 17 },
  { label: 'Impuesto Positivo', value: 18 },
  { label: 'Impuesto Negativo', value: 19 },
  { label: 'Flujo de Caja Administrativo', value: 20 },
  { label: 'Activos Fijos', value: 21 },
  { label: 'Sin Uso', value: 22 },
];

export const ENTRY_TYPE = [
  { label: 'Débito', value: 0 },
  { label: 'Crédito', value: 1 },
];

export const PROCEDENT_TYPE = [
  { label: 'Inventario Inicial', value: 0 },
  { label: 'Ajuste de Inventario', value: 1 },
  { label: 'Compra de Productos', value: 2 },
  { label: 'Devolución de Productos', value: 3 },
  { label: 'Orden Médica', value: 4 },
  { label: 'Emisión Cheque Proveedor', value: 5 },
  { label: 'Emisión Cheque Otros', value: 6 },
  { label: 'Kardex Medicamento', value: 7 },
  { label: 'Facturación Paciente', value: 8 },
  { label: 'Cambio Estado Inventario', value: 9 },
  { label: 'Solicitud Productos por Turno', value: 10 },
  { label: 'Orden de Compra', value: 11 },
  { label: 'Orden de Requisición', value: 12 },
  { label: 'Compra Directa Productos', value: 13 },
  { label: 'Transferencia Almacén', value: 14 },
  { label: 'Solicitud Materiales Gastables', value: 15 },
  { label: 'Admisión', value: 16 },
  { label: 'Asiento Manual', value: 17 },
  { label: 'Activos Fijos', value: 18 },
  { label: 'Depreciación de Activos Fijos', value: 19 },
  { label: 'Nómina', value: 20 },
];

export const EMPLOYEE_STATUS_EXTENDED = [
  { label: 'Activo', value: 0 },
  { label: 'Inactivo', value: 1 },
  { label: 'De Vacaciones', value: 2 },
  { label: 'De Permiso', value: 3 },
  { label: 'De Licencia', value: 4 },
  { label: 'De Licencia por Maternidad', value: 5 },
  { label: 'De Licencia Parental', value: 6 },
];

export const MARITAL_STATUS = [
  { label: 'Soltero', value: 0 },
  { label: 'Casado', value: 1 },
  { label: 'Union Libre', value: 2 },
  { label: 'Divorciado', value: 3 },
];

export const optionsDocumentTypes = [
  { value: 0, label: 'Pasaporte' },
  { value: 1, label: 'Cedula' },
];

export const optionsGender = [
  { value: 'm', label: 'Masculino' },
  { value: 'f', label: 'Femenino' },
];
export const MedicalServicesType = [
  { value: 0, label: 'Laboratory' },
  { value: 1, label: 'Images' },
  { value: 2, label: 'Cardiology' },
  { value: 3, label: 'Surgery' },
  { value: 4, label: 'SpecialStudies' },
];

export const INVOICE_ACCOUNTING_TYPE = [
  {
    value: 0,
    valueFromEnum: 'forProvider',
    label: 'Cobrar a Proveedor',
    description: 'Para registrar una factura de cobrar a un proveedor',
  },
  {
    value: 1,
    valueFromEnum: 'fromProvider',
    label: 'Pagar a Proveedor',
    description: 'Para registrar una factura de pagar a un proveedor',
  },
  {
    value: 2,
    valueFromEnum: 'returnedForProvider',
    label: 'Nota de Crédito para un Proveedor',
    description: 'Para registrar una nota de crédito para un proveedor',
  },
  {
    value: 3,
    valueFromEnum: 'returnedFromProvider',
    label: 'Nota de Crédito de parte de Proveedor',
    description: 'Para registrar una nota de crédito de un proveedor',
  },
];
export const InsuranceTypeCard = [
  { value: 0, label: 'Carnet Físico' },
  { value: 1, label: 'Carnet Digital' },
  { value: 2, label: 'Sin Seguro Médico' },
];

// ----------------------------------------------------------------------
// ACTIVOS FIJOS (enteros del backend MEDICORE.DATA/ENUM/FIXEDASSETS/*.cs)
// ----------------------------------------------------------------------

export const FIXED_ASSET_STATUS = [
  { value: 0, label: 'Activo' },
  { value: 1, label: 'En almacén' },
  { value: 2, label: 'En mantenimiento' },
  { value: 3, label: 'Fuera de servicio' },
  { value: 4, label: 'Dañado' },
  { value: 5, label: 'Perdido' },
  { value: 6, label: 'Pendiente de baja' },
  { value: 7, label: 'Vendido' },
  { value: 8, label: 'Donado' },
  { value: 9, label: 'Desechado' },
  { value: 10, label: 'Dado de baja' },
];

// Estados terminales: no se puede salir de ellos ni entrar por "cambiar estado" (solo por baja).
export const FIXED_ASSET_TERMINAL_STATUSES = [5, 7, 8, 9, 10];

export const DEPRECIATION_METHOD = [
  { value: 0, label: 'Sin depreciación' },
  { value: 1, label: 'Línea recta' },
  { value: 2, label: 'Unidades de producción' },
];

export const USAGE_UNIT_TYPE = [
  { value: 0, label: 'Ninguna' },
  { value: 1, label: 'Horas' },
  { value: 2, label: 'Ciclos' },
  { value: 3, label: 'Procedimientos' },
  { value: 4, label: 'Exposiciones' },
  { value: 5, label: 'Escaneos' },
  { value: 6, label: 'Kilómetros' },
  { value: 7, label: 'Pruebas' },
  { value: 8, label: 'Cargas' },
];

export const CAPITALIZATION_MODE = [
  {
    value: 0,
    label: 'Generar asiento de alta',
    description:
      'Se registra el alta contra la cuenta puente 12010501 · Activos fijos por capitalizar. La factura de compra debe contabilizarse contra esa cuenta puente.',
  },
  {
    value: 1,
    label: 'Ya está en el mayor',
    description:
      'La factura ya se contabilizó en la cuenta del activo: no se genera alta, pero sí apertura y depreciación.',
  },
  {
    value: 2,
    label: 'No aplica (solo inventario físico)',
    description: 'Fuera de contabilidad: nunca se deprecia contablemente.',
  },
];

export const DISPOSAL_TYPE = [
  { value: 0, label: 'Venta' },
  { value: 1, label: 'Donación' },
  { value: 2, label: 'Pérdida' },
  { value: 3, label: 'Robo' },
  { value: 4, label: 'Desecho' },
];

export const DGII_ASSET_CATEGORY = [
  { value: 0, label: 'Sin categoría' },
  { value: 1, label: 'Categoría 1 (edificaciones)' },
  { value: 2, label: 'Categoría 2 (mobiliario, vehículos, equipos de oficina)' },
  { value: 3, label: 'Categoría 3 (otros activos)' },
];

export const FIXED_ASSET_EVENT_TYPE = [
  { value: 0, label: 'Registrado' },
  { value: 1, label: 'Capitalizado' },
  { value: 2, label: 'Apertura' },
  { value: 3, label: 'Actualizado' },
  { value: 4, label: 'Transferencia' },
  { value: 5, label: 'Cambio de custodio' },
  { value: 6, label: 'Cambio de estado' },
  { value: 7, label: 'Depreciación' },
  { value: 8, label: 'Mejora' },
  { value: 9, label: 'Lectura de contador' },
  { value: 10, label: 'Cambio de política de depreciación' },
  { value: 11, label: 'Baja' },
  { value: 12, label: 'Etiqueta impresa' },
  { value: 13, label: 'Documento adjuntado' },
  { value: 14, label: 'Eliminado' },
];

export const DEPRECIATION_RUN_STATUS = [
  { value: 0, label: 'Pendiente' },
  { value: 1, label: 'En ejecución' },
  { value: 2, label: 'Completado' },
  { value: 3, label: 'Parcialmente fallido' },
  { value: 4, label: 'Fallido' },
];

export const BACKFILL_STATUS = [
  { value: 0, label: 'No ejecutado' },
  { value: 1, label: 'En ejecución' },
  { value: 2, label: 'Completado' },
  { value: 3, label: 'Fallido' },
];

export const FIRST_MONTH_CONVENTION = [
  { value: 0, label: 'Mes completo' },
  { value: 1, label: 'Prorrateo por días' },
  { value: 2, label: 'Mes siguiente' },
];

// Tamaños de etiqueta que acepta `label.pdf?size=` (el valor viaja tal cual al backend).
// '56x25' es el tamaño por defecto (impresora 4BARCODE 4B-3062A) y va primero.
export const LABEL_SIZES = [
  { value: '56x25', label: '56 × 25 mm — 4BARCODE 4B-3062A', widthMm: 56, heightMm: 25 },
  { value: '50x30', label: '50 × 30 mm', widthMm: 50, heightMm: 30 },
  { value: '62x29', label: '62 × 29 mm', widthMm: 62, heightMm: 29 },
  { value: '2x1in', label: '2 × 1 pulgadas', widthMm: 50.8, heightMm: 25.4 },
];

// `LabelExportKind` (MEDICORE.DATA/ENUM/FIXEDASSETS) — kind de la impresión de etiqueta.
export const LABEL_EXPORT_KIND = [
  { value: 0, label: 'Individual' },
  { value: 1, label: 'Selección' },
  { value: 2, label: 'Departamento' },
  { value: 3, label: 'Todos' },
  { value: 4, label: 'Traslado' },
];
